import Vue from 'vue'
import Router from 'vue-router'
import VueRouterBackButton from 'vue-router-back-button'

import PublicLoginPage from '@/components/pages/Login/LoginPage'
import PublicForgotPasswordPage from '@/components/pages/Login/ForgotPasswordPage'
import PublicResetPasswordPage from '@/components/pages/Login/ResetPasswordPage'

import HomeWorkOrdersPage from '@/components/pages/Admin/Home/WorkOrdersPage'
import HomeSharePage from '@/components/pages/Admin/Home/SharePage'

import CustomersPage from '@/components/pages/Admin/Customer/CustomersPage'

import ProjectsPage from '@/components/pages/Admin/Projects/ProjectsPage'
import ProjectDetails from '@/components/pages/Admin/Projects/ProjectDetails'

import ProjectWorkOrdersPage from '@/components/pages/Admin/Projects/ProjectWorkOrdersPage'

import ContactPersonsPage from '@/components/pages/Admin/Contacts/PersonsPage'
import ContactAddressesPage from '@/components/pages/Admin/Contacts/AddressesPage'

import InvoicesPage from '@/components/pages/Admin/Invoices/InvoicesPage'
import InvoiceArchivePage from '@/components/pages/Admin/Invoices/InvoiceArchivePage'

// import TimeReportCreatePage from '@/components/pages/Admin/TimeReport/CreatePage'
// import TimeReportHistoryPage from '@/components/pages/Admin/TimeReport/HistoryPage'
// import TimeReportBalancePage from '@/components/pages/Admin/TimeReport/BalancePage'

import SettingsPreferencesPage from '@/components/pages/Admin/Settings/PreferencesPage'
import SettingsDevPage from '@/components/pages/Admin/Settings/DevPage'
import SettingsProducts from '@/components/pages/Admin/Settings/ProductsPage'

import SystemSettingsPage from '@/components/pages/Admin/Settings/SystemSettingsPage'

import SuperAdminUsersPage from '@/components/pages/Admin/SuperAdmin/UsersPage'
import SuperAdminDeliveryTemplatesPage from '@/components/pages/Admin/SuperAdmin/DeliveryTemplatesPage'
import SuperAdminPriceListsDefaultPage from '@/components/pages/Admin/SuperAdmin/PriceListsDefaultPage'
import SuperAdminPriceListsCustomerPage from '@/components/pages/Admin/SuperAdmin/PriceListsCustomerPage'
import SuperAdminTagsPage from '@/components/pages/Admin/SuperAdmin/TagsPage'

import StaffTimeLogPage from '@/components/pages/Admin/StaffTimeLog/StaffTimeLogPage'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    // Fortnox activation
    {
      path: '/fortnox/activation',
      name: 'FortnoxActivation',
      component: () => import('@/components/pages/Other/Fortnox/FortnoxActivationPage.vue'),
      meta: {
        layout: 'empty',
        title: 'Fortnox-koppling klar',
        public: true
      }
    },

    // Login page
    {
      path: '/',
      name: 'Public_Login',
      component: PublicLoginPage,
      meta: {
        layout: 'login',
        title: 'Logga in'
      }
    },

    // Forgot password
    {
      path: '/forgot-password',
      name: 'Public_ForgotPassword',
      component: PublicForgotPasswordPage,
      meta: {
        layout: 'login',
        title: 'Glömt PIN'
      }
    },

    // Reset password
    {
      path: '/reset-password/:token',
      name: 'Public_ResetPassword',
      component: PublicResetPasswordPage,
      meta: {
        layout: 'login',
        title: 'Välj nytt PIN'
      }
    },

    // Home » Project owner
    {
      path: '/home/project-owner',
      name: 'Home_ProjectOwner',
      component: ProjectsPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Hem » Ansvarig'
      }
    },

    // Home » Project reviewer
    {
      path: '/home/project-reviewer',
      name: 'Home_ProjectReviewer',
      component: ProjectsPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Hem » Granskare'
      }
    },

    // Home » Work orders
    {
      path: '/home/work-orders',
      name: 'Home_WorkOrders',
      component: HomeWorkOrdersPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Hem » Insatser'
      }
    },

    // Home » Share
    {
      path: '/home/share',
      name: 'Home_SharePage',
      component: HomeSharePage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Hem » Dela'
      }
    },

    // Customers
    {
      path: '/customers',
      name: 'Customers',
      component: CustomersPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Kunder'
      }
    },

    // Customers » Information
    /*  {
      path: '/customer/:customerId',
      name: 'Customer_Information',
      component: CustomerDetailsPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Kundinformation'
      }
    }, */

    // Projects
    {
      path: '/projects',
      name: 'Projects',
      component: ProjectsPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Projekt'
      }
    },

    // Project Details
    {
      path: '/projectdetails/:projectId',
      name: 'Project_Details',
      component: ProjectDetails,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Projektdetaljer'
      }
    },

    // Projects » Work orders
    {
      path: '/work-orders/project/:projectCode',
      name: 'Project_WorkOrders',
      component: ProjectWorkOrdersPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: ''
      }
    },

    // Contacts » Persons
    {
      path: '/contact/persons',
      name: 'Contacts_Persons',
      component: ContactPersonsPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Personer'
      }
    },
    {
      path: '/contact/persons/project/:projectId',
      name: 'Contacts_Persons_Project',
      component: ContactPersonsPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Personer'
      }
    },

    // Contacts » Addresses
    {
      path: '/contact/addresses',
      name: 'Contacts_Addresses',
      component: ContactAddressesPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Adresser'
      }
    },
    {
      path: '/contact/addresses/project/:projectId',
      name: 'Contacts_Addresses_Project',
      component: ContactAddressesPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Projektadresser'
      }
    },

    // Invoices
    {
      path: '/invoices',
      name: 'Invoices',
      component: InvoicesPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Fakturera'
      }
    },

    {
      path: '/invoices/project/:projectCode',
      name: 'Invoices_Project',
      component: InvoicesPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Fakturera'
      }
    },

    {
      path: '/invoices/archive',
      name: 'Invoices_Archive',
      component: InvoiceArchivePage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Fakturor » Reskontra'
      }
    },

    {
      path: '/invoices/archive/my',
      name: 'Invoices_Archive_My',
      component: InvoiceArchivePage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Fakturor » Ansvarig'
      }
    },

    {
      path: '/invoices/archive/overdue',
      name: 'Invoices_Archive_Overdue',
      component: InvoiceArchivePage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Fakturor » Förfallna'
      }
    },

    // Time report » Create
    // {
    //   path: '/time-report/create',
    //   name: 'TimeReport_Create',
    //   component: TimeReportCreatePage,
    //   minimumRole: 'Staff',
    //   meta: {
    //     layout: 'admin',
    //     title: 'Skapa tidrapport'
    //   }
    // },

    // Time report » History
    // {
    //   path: '/time-report/history',
    //   name: 'TimeReport_History',
    //   component: TimeReportHistoryPage,
    //   minimumRole: 'Staff',
    //   meta: {
    //     layout: 'admin',
    //     title: 'Tidrapporteringsistorik'
    //   }
    // },

    // Time report » Balance
    // {
    //   path: '/time-report/balance',
    //   name: 'TimeReport_Balance',
    //   component: TimeReportBalancePage,
    //   minimumRole: 'Staff',
    //   meta: {
    //     layout: 'admin',
    //     title: 'Saldo'
    //   }
    // },

    // Settings » Preferences
    {
      path: '/settings/preferences',
      name: 'Settings_Preferences',
      component: SettingsPreferencesPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Gränssnitt'
      }
    },

    // Settings » Dev
    {
      path: '/settings/dev',
      name: 'Settings_Dev',
      component: SettingsDevPage,
      minimumRole: 'Developer',
      meta: {
        layout: 'admin',
        title: 'Dev\'s lounge'
      }
    },

    // Settings » System settings
    {
      path: '/settings/system-settings',
      name: 'Settings_SystemSettings',
      component: SystemSettingsPage,
      minimumRole: 'SuperAdmin',
      meta: {
        layout: 'admin',
        title: 'Systeminställningar'
      }
    },

    // Settings » Product configurator
    {
      path: '/settings/products',
      name: 'Settings_Products',
      component: SettingsProducts,
      minimumRole: 'SuperAdmin',
      meta: {
        layout: 'admin',
        title: 'Produkter'
      }
    },

    // SuperAdmin » Users
    {
      path: '/superadmin/users',
      name: 'SuperAdmin_Users',
      component: SuperAdminUsersPage,
      minimumRole: 'SuperAdmin',
      meta: {
        layout: 'admin',
        title: 'Användare',
        headingIcon: 'fa-users'
      }
    },

    // SuperAdmin » Price lists default
    {
      path: '/superadmin/price-lists-default',
      name: 'SuperAdmin_PriceListsDefault',
      component: SuperAdminPriceListsDefaultPage,
      minimumRole: 'SuperAdmin',
      meta: {
        layout: 'admin',
        title: 'Prislistor - standard'
      }
    },

    // SuperAdmin » Price lists customer
    {
      path: '/superadmin/price-lists-customer',
      name: 'SuperAdmin_PriceListsCustomer',
      component: SuperAdminPriceListsCustomerPage,
      minimumRole: 'SuperAdmin',
      meta: {
        layout: 'admin',
        title: 'Prislistor - kund'
      }
    },

    // SuperAdmin » Users
    {
      path: '/superadmin/delivery-templates',
      name: 'SuperAdmin_DeliveryTemplates',
      component: SuperAdminDeliveryTemplatesPage,
      minimumRole: 'SuperAdmin',
      meta: {
        layout: 'admin',
        title: 'Leveransmallar'
      }
    },

    // SuperAdmin » Tags
    {
      path: '/superadmin/tags',
      name: 'SuperAdmin_Tags',
      component: SuperAdminTagsPage,
      minimumRole: 'SuperAdmin',
      meta: {
        layout: 'admin',
        title: 'Taggar'
      }
    },

    // StaffTimeLog
    {
      path: '/stafftimelogs',
      name: 'StaffTimeLogs',
      component: StaffTimeLogPage,
      minimumRole: 'Staff',
      meta: {
        layout: 'admin',
        title: 'Kundkontakter'
      }
    },

    // otherwise redirect to home
    { path: '*', redirect: '/404' }
  ]
})

Vue.use(VueRouterBackButton, { router })

router.beforeEach((to, from, next) => {
  const user = localStorage.getItem('user')
  const publicPages = ['/', '/forgot-password', '/reset-password']
  const authRequired = !publicPages.includes(to.path)

  if (to.name === 'Project_WorkOrders') {
    to.meta.title = to.params.projectCode + ' » Insatser'
  }

  // Authentication is required but no user isn't logged in, let's redirect to login
  if (authRequired && !user) {
    Vue.prototype.$alert('Din session är avslutad, vänligen logga in igen...')
    return next('/')
  }

  // Authentication is required and user is logged in, let's authorize
  if (authRequired) {
    const roles = ['Staff', 'SuperAdmin', 'Developer']

    if (roles.indexOf(to.minimumRole) > roles.indexOf(user.role)) {
      Vue.prototype.$alert('Du har inte tillräcklig behörighet, sorry...').then(() => {
        return next(false)
      })
    }
  }

  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js